import React from 'react';
import styles from './LegendTab.module.scss';

const LegendTab: React.FC = () => {
  return (
    <div className={styles.legendContainer}>
      <div className={styles.legendList}>
        <div className={styles.legendItem}>
          <div className={styles.legendModule} />
          <span>Drop zone</span>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendFailback} />
          <span>Failback drop zone</span>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendChildModule} />
          <span>Nested drop zone</span>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendChildFailback} />
          <span>Nested failback drop zone</span>
        </div>
      </div>
    </div>
  );
};

export default LegendTab;
